










































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class Thumbnail extends Vue {
  @Prop() id!: string

  url = ''
  loading = true

  mounted () {
    const url = ((this.$store.getters.server.url.startsWith('https://') || this.$store.getters.server.url.startsWith('http://')) ? this.$store.getters.server.url : 'https://' + this.$store.getters.server.url) + '/doc/' + this.id + '/thumb'
    const options = {
      headers: {
        Authorization: this.$store.getters.server.server.headers.get('Authorization')
      }
    }

    fetch(url, options)
      .then(r => r.blob())
      .then(b => {
        this.loading = false
        this.url = URL.createObjectURL(b)
      }).catch(() => {
        this.loading = false
      })
  }
}
